import React from "react";

import Loading from "../components/loading/Loading";
import Loadable from "react-loadable";
import http from "../utils/http";

import helper from "../utils/helper";
// const client = helper.getQuery("client");
/**
 * 按需加载模块
 */

const OpenLogin = Loadable({
	loader: () => {
		const componentName = +helper.getQuery("client") === 0 ? 'open-login-v2' : 'open-login';
		return import(`../pages/common/${componentName}`)
	},
	loading: Loading
});
const OpenLoginOperation = Loadable({
	loader: () => import("../pages/common/open-login-operation"),
	loading: Loading
});
const Logout = Loadable({
	loader: () => import("../pages/common/logout"),
	loading: Loading
});
// const TouchRegister = Loadable({
//   loader: () => import("../pages/touch/register/"),
//   loading: Loading
// });
const TouchSignUp = Loadable({
	loader: () => import("../pages/touch/register-v2/"),
	loading: Loading
});
const TouchLoginDispatch = Loadable({
	loader: () => import("../pages/touch/dispatch/"),
	loading: Loading
});

const TouchLogin = Loadable({
	loader: () => import("../pages/touch/login-v2/"),
	loading: Loading
});

// const TouchUnionLogin = Loadable({
//   loader: () => import("../pages/touch/union-login/"),
//   loading: Loading
// });

const TouchUnionLoginV2 = Loadable({
	loader: () => import("../pages/touch/union-login-v2/"),
	loading: Loading
});
const TouchRetrieve = Loadable({
	loader: () => import("../pages/touch/reset-password/retrieve"),
	loading: Loading
});
const TouchRetrieveWithMobile = Loadable({
	loader: () => import("../pages/touch/reset-password/retrieve-mobile"),
	loading: Loading
});
const TouchRetrieveSendEmail = Loadable({
	loader: () => import("../pages/touch/reset-password/retrieve-send-mail"),
	loading: Loading
});
const TouchRetrieveSendEmailResult = Loadable({
	loader: () => import("../pages/touch/reset-password/retrieve-mail-result"),
	loading: Loading
});
const TouchRetrieveAuthEmail = Loadable({
	loader: () => import("../pages/touch/reset-password/retrieve-mail"),
	loading: Loading
});
const TouchRestPassword = Loadable({
	loader: () => import("../pages/touch/reset-password/retrieve-password"),
	loading: Loading
});
const TouchSetPassword = Loadable({
	loader: () => import('../pages/touch/reset-password/set-password'),
	loading: Loading
});
// 解绑账号
const ChooseBinding = Loadable({
	loader: () => import('../pages/touch/choose-binding/index'),
	loading: Loading
})

// const WwwRegister = Loadable({
//   loader: () => import("../pages/www/register"),
//   loading: Loading
// });
const WwwRegister = Loadable.Map({
	loader: {
		pageComponent: () => import("../pages/www/register"),
		backgroundImg: () => http.get("/api/products/queryPcLoginBackgroundAdvertisement", {
			isLoadingMask: false,
			timeout: 3000
		}).then(res => {
			let data = res.data;
			if (data.status && data.status === "00000") {
				return res.data.result || {};
			} else {
				return {
					error: true,
					status: data.status,
					message: data.message || '请求错误'
				};
			}
		}).catch(err => {
			return {
				error: true,
				status: '-111111',
				message: '请求失败'
			};
		})
	},
	render(loaded, props) {
		let PageComponent = loaded.pageComponent.default;
		let bgImg = loaded.backgroundImg;
		return <PageComponent {...props} bgImg={bgImg}/>;
	},
	loading: Loading
});
// const WwwLogin = Loadable({
//   loader: () => import("../pages/www/login"),
//   loading: Loading
// });
const WwwLogin = Loadable.Map({
	loader: {
		pageComponent: () => import("../pages/www/login"),
		backgroundImg: () => http.get("/api/products/queryPcLoginBackgroundAdvertisement", {isLoadingMask: false}).then(res => {
			let data = res.data;
			if (data.status && data.status === "00000") {
				return res.data.result || {};
			} else {
				return {
					error: true,
					status: data.status,
					message: data.message || '请求错误'
				};
			}
		}).catch(err => {
			return {
				error: true,
				status: '-111111',
				message: '请求失败'
			};
		})
	},
	render(loaded, props) {
		let PageComponent = loaded.pageComponent.default;
		let bgImg = loaded.backgroundImg;
		return <PageComponent {...props} bgImg={bgImg}/>;
	},
	loading: Loading
});
const WwwRetrieve = Loadable({
	loader: () => import("../pages/www/reset-password/retrieve"),
	loading: Loading
});
const WwwRetrieveAuth = Loadable({
	loader: () => import("../pages/www/reset-password/retrieve-auth"),
	loading: Loading
});
const WwwRetrieveMail = Loadable({
	loader: () => import("../pages/www/reset-password/retrieve-mail"),
	loading: Loading
});
const WwwRestPassword = Loadable({
	loader: () => import("../pages/www/reset-password/retrieve-password"),
	loading: Loading
});
// const WwwUnionLogin = Loadable({
//   loader: () => import("../pages/www/union-login/"),
//   loading: Loading
// });

const WwwUnionLogin = Loadable.Map({
	loader: {
		pageComponent: () => import("../pages/www/union-login/"),
		backgroundImg: () => http.get("/api/products/queryPcLoginBackgroundAdvertisement", {isLoadingMask: false}).then(res => {
			let data = res.data;
			if (data.status && data.status === "00000") {
				return res.data.result || {};
			} else {
				return {
					error: true,
					status: data.status,
					message: data.message || '请求错误'
				};
			}
		}).catch(err => {
			return {
				error: true,
				status: '-111111',
				message: '请求失败'
			};
		})
	},
	render(loaded, props) {
		let PageComponent = loaded.pageComponent.default;
		let bgImg = loaded.backgroundImg;
		return <PageComponent {...props} bgImg={bgImg}/>;
	},
	loading: Loading
});
/**
 * @name 设置路由
 * @description main 必须
 * @date 2018/08/31
 */
const routerMap = [
	//首页
	{path: "/", exact: true, main: () => <WwwLogin/>},

	{path: "/signin", exact: true, main: () => <WwwLogin/>}, //兼容老页面

	{path: "/open-login", exact: true, main: () => <OpenLogin/>}, //注册

	{path: "/logout", exact: true, main: () => <Logout/>}, //注册

	/**
	 * 移动端路由
	 */

	{path: "/m-sso/register", exact: true, main: () => <TouchSignUp/>}, //注册

	{path: "/m-sso/login", exact: true, main: () => <TouchLoginDispatch/>}, //登录

	// { path: "/m-sso/union-login", exact: true, main: () => <TouchUnionLogin /> }, //登录

	{path: "/m-sso/union-login", exact: true, main: () => <TouchUnionLoginV2/>}, //登录

	{path: "/m-sso/retrieve", exact: true, main: () => <TouchRetrieve/>}, //找回密码

	{
		path: "/m-sso/signin/mobile",
		exact: true,
		main: () => <TouchLogin/>
	}, //手机登录

	{
		path: "/m-sso/signin/password",
		exact: true,
		main: () => <TouchLogin/>
	}, //密码登录

	// { path: "/m-sso/signup/mobile", exact: true, main: () => <TouchSignUp /> }, //手机注册

	{
		path: "/m-sso/retrieve-mobile",
		exact: true,
		main: () => <TouchRetrieveWithMobile/>
	}, //用手机号验证

	{
		path: "/m-sso/retrieve-send-mail",
		exact: true,
		main: () => <TouchRetrieveSendEmail/>
	}, //用手机号验证

	{
		path: "/m-sso/retrieve-mail",
		exact: true,
		main: () => <TouchRetrieveAuthEmail/>
	}, //用手机号验证

	{
		path: "/m-sso/retrieve-mail-result",
		exact: true,
		main: () => <TouchRetrieveSendEmailResult/>
	}, //用手机号验证

	{
		path: "/m-sso/retrieve-password",
		exact: true,
		main: () => <TouchRestPassword/>
	}, //重置密码

	{
		path: '/m-sso/set-password',
		extra: true,
		main: () => <TouchSetPassword/>
		// 设置密码

	}, // 设置密码
	{path: "/open-login-operation", exact: true, main: () => <OpenLoginOperation/>}, // h5活动登录框（转介绍等，只支持验证码登录/注册）

	{
		path: '/m-sso/choose-binding',
		extra: true,
		main: () => <ChooseBinding/>
	}, //解绑账号
	/**
	 * PC端路由
	 */
	{path: "/register", exact: true, main: () => <WwwRegister/>}, //注册

	// { path : '/login', exact : true, main : () => <WwwLogin/> },//登录

	{path: "/union-login", exact: true, main: () => <WwwUnionLogin/>}, //登录

	{path: "/retrieve", exact: true, main: () => <WwwRetrieve/>}, //找回密码

	{path: "/retrieve-auth", exact: true, main: () => <WwwRetrieveAuth/>}, //用手机号验证

	{path: "/retrieve-mail", exact: true, main: () => <WwwRetrieveMail/>}, //用手机号验证

	{path: "/retrieve-password", exact: true, main: () => <WwwRestPassword/>} //重置密码
];

export default routerMap;



// WEBPACK FOOTER //
// ./src/router/router-map.js